import {
  IMessageLevelCount,
  MessageFilterInput
}                               from '../DataTypes';
import DataQueries              from '../graphql/Queries';
import EntityPollingService, {
  EntityPollingModel,
  PollingCallbackFn,
}                               from './EntityPollingService';

export type MessageCountSort = (e1: IMessageLevelCount, e2: IMessageLevelCount) => number;

export function defaultMessageCountSort(e1: IMessageLevelCount, e2: IMessageLevelCount) {
  return e1.level.localeCompare(e2.level);
}

export class MessageCountsPollingModel extends EntityPollingModel<IMessageLevelCount> {
  constructor(options?: {filter?: MessageFilterInput, updateDelay?: number, externalEntitiesContainer?: IMessageLevelCount[], pollingCallback?: PollingCallbackFn}) {
    super({filter: options?.filter as Record<string, unknown> | undefined, sort: defaultMessageCountSort, updateDelay: options?.updateDelay, externalEntitiesContainer: options?.externalEntitiesContainer, pollingCallback: options?.pollingCallback});
  }

  set messageCounts(value: IMessageLevelCount[]) {
    this.entities = value;
  }

  get messageCounts(): IMessageLevelCount[] {
    return this.entities;
  }

  get errorMessagesCount(): number {
    return this.messageCounts.find(mc => mc.level === 'error')?.count ?? 0;
  }

  get warningMessagesCount(): number {
    return this.messageCounts.find(mc => mc.level === 'warning')?.count ?? 0;
  }

  get infoMessagesCount(): number {
    return this.messageCounts.find(mc => mc.level === 'info')?.count ?? 0;
  }

  get successMessagesCount(): number {
    return this.messageCounts.find(mc => mc.level === 'success')?.count ?? 0;
  }

  protected async _getEntities(): Promise<IMessageLevelCount[]> {
    return await DataQueries.getMessagesCounts(this.filter);
  }
}

class MessageCountsPollingService extends EntityPollingService<IMessageLevelCount, MessageCountsPollingModel> {
  constructor() {
    super();
  }

  protected _createPollingModel(options?: {filter?: MessageFilterInput, updateDelay?: number, externalEntitiesContainer?: IMessageLevelCount[], pollingCallback?: PollingCallbackFn}): MessageCountsPollingModel {
    return new MessageCountsPollingModel(options);
  }
}

const messageCountsPollingService = new MessageCountsPollingService();
export default messageCountsPollingService;
